import React from "react";
import styles from "./Carousel.module.scss";
export default function CarouselPaging({ active }) {
  return (
    <span className={`${styles.dot} ${active ? styles.active : ""}`}>
      <span></span>
    </span>
  );
}
